import React, { useCallback, useState } from "react";
import { Paper, Box, Tabs, Tab, Container, Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendarDay,
  faCreditCard,
  faDonate,
  faHouseLaptop,
} from "@fortawesome/free-solid-svg-icons";
import PropTypes from "prop-types";
import { useNavigate, useParams } from "react-router-dom";

import { getRuta } from "../../../helpers/Helpers";
import { PageHeader } from "../../../components/base";
import CreditDetails from "./CreditDetails";
import CreditGarantias from "./CreditGarantias";
import CreditPayment from "./CreditPayment";
import CreditAbono from "./CreditAbono";
import ResumenCredito from "./ResumenCredito";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`credito-tabpanel-${index}`}
      aria-labelledby={`credito-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

// Cada pestaña lleva su propio índice: el id de la pestaña y el del panel se corresponden.
function a11yProps(index) {
  return {
    id: `credito-tab-${index}`,
    "aria-controls": `credito-tabpanel-${index}`,
  };
}

const PLAN_SIN_CARGAR = { saldo: null, mora: null };

const CreditDetailsContainer = () => {
  let ruta = getRuta();
  let navigate = useNavigate();
  const { id } = useParams();
  const [value, setValue] = useState(0);
  const [clientName, setClientName] = useState("");
  const [dataCredit, setDataCredit] = useState("");
  const [isNominal, setIsNominal] = useState(false);

  // Lo que el plan de pagos ya calculó (saldo y mora), para el resumen del encabezado.
  // Se descarta cuando cambian los abonos: así el resumen nunca muestra una cifra vieja.
  const [plan, setPlan] = useState(PLAN_SIN_CARGAR);
  const alCargarPlan = useCallback((datos) => setPlan(datos), []);
  const alCambiarAbonos = useCallback(() => setPlan(PLAN_SIN_CARGAR), []);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Container maxWidth={false} disableGutters>
      <Button
        onClick={() => {
          navigate(`${ruta}/credits`);
        }}
        startIcon={<ArrowBackIcon />}
        sx={{ mb: 1 }}
      >
        Volver a créditos
      </Button>

      <PageHeader
        titulo={clientName || "Detalle del crédito"}
        subtitulo={`Crédito #${id}`}
        icono={<FontAwesomeIcon icon={faCreditCard} />}
      />

      <ResumenCredito
        credito={dataCredit}
        saldo={plan.saldo}
        mora={plan.mora}
        onVerSaldo={() => setValue(2)}
      />

      <Paper sx={{ p: { xs: 2, sm: 3 } }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="Secciones del crédito"
          variant="scrollable"
          scrollButtons="auto"
          sx={{ borderBottom: 1, borderColor: "divider" }}
        >
          <Tab
            icon={<FontAwesomeIcon icon={faCreditCard} />}
            iconPosition="start"
            label="Crédito"
            {...a11yProps(0)}
          />

          <Tab
            icon={<FontAwesomeIcon icon={faHouseLaptop} />}
            iconPosition="start"
            label="Garantías"
            {...a11yProps(1)}
          />

          <Tab
            icon={<FontAwesomeIcon icon={faCalendarDay} />}
            iconPosition="start"
            label="Plan de pagos"
            {...a11yProps(2)}
          />

          <Tab
            icon={<FontAwesomeIcon icon={faDonate} />}
            iconPosition="start"
            label="Abonos"
            {...a11yProps(3)}
          />
        </Tabs>

        <TabPanel value={value} index={0}>
          <CreditDetails
            id={id}
            clientName={clientName}
            setClientName={setClientName}
            isNominal={isNominal}
            setIsNominal={setIsNominal}
            setDataCredit={setDataCredit}
            onPlanReconstruido={alCambiarAbonos}
          />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <CreditGarantias id={id} />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <CreditPayment
            id={id}
            clientName={clientName}
            isNominal={isNominal}
            dataCredit={dataCredit}
            onPlanCargado={alCargarPlan}
          />
        </TabPanel>
        <TabPanel value={value} index={3}>
          <CreditAbono
            id={id}
            clientName={clientName}
            isNominal={isNominal}
            onAbonosCambiaron={alCambiarAbonos}
          />
        </TabPanel>
      </Paper>
    </Container>
  );
};

export default CreditDetailsContainer;
